// extracted by mini-css-extract-plugin
export default {"button":"SelectedButton_button__Fhf1w","focus":"SelectedButton_focus__oYZML","leading":"SelectedButton_leading__aT-0K","text":"SelectedButton_text__88WYs"};